import React, { useEffect } from 'react';
import FadeIn from '../components/FadeIn';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiArrowLeft } from 'react-icons/fi';

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <FadeIn>
          <Link 
            to="/" 
            className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium mb-8 transition-colors"
          >
            <SafeIcon icon={FiArrowLeft} className="mr-2" /> 
            Back to Home
          </Link>

          <h1 className="text-4xl font-bold text-slate-900 mb-4">Terms & Conditions</h1>
          <p className="text-slate-500 mb-10 italic">Last Updated: {new Date().toLocaleDateString()}</p>
          
          <div className="prose prose-slate max-w-none space-y-8 text-slate-700 leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4">1. Digital Product Nature</h2>
              <p>
                The "7-Day Bill Panic Reset" is a digital educational video course. By purchasing this product, you understand that you are buying access to recorded video content and digital templates intended for educational and informational purposes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4">2. License for Personal Use</h2>
              <p>
                Upon purchase, we grant you a single-user, non-exclusive, non-transferable license to access the course content for your own personal, non-commercial use.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4">3. Prohibited Actions</h2>
              <p>
                You are strictly prohibited from sharing your access credentials, copying, reselling, distributing, or publicly displaying any part of the course materials. Any unauthorized distribution will result in immediate termination of access without refund and may lead to legal action.
              </p>
            </section>

            <section className="bg-slate-50 p-6 rounded-xl border border-slate-200">
              <h2 className="text-xl font-bold text-slate-900 mb-4">4. No Refund Policy</h2>
              <p className="font-medium">
                Due to the nature of instant digital access, all sales of the "7-Day Bill Panic Reset" are final. No refunds will be issued once purchase is complete and access to the video content is granted.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4">5. Professional Advice Disclaimer</h2>
              <p>
                This course is for educational purposes only. The creators of "7-Day Bill Panic Reset" are not financial advisors, attorneys, or certified public accountants. This course does not provide financial, legal, or professional tax advice. You are encouraged to consult with a qualified professional for specific financial advice tailored to your situation.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4">6. Limitation of Liability</h2>
              <p>
                Under no circumstances shall the creators or distributors of this course be liable for any direct, indirect, or consequential damages resulting from the use or inability to use the information provided. Your financial results are dependent on your own actions and external market factors.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-900 mb-4">7. Right to Modify</h2>
              <p>
                We reserve the right to update, modify, or remove content within the course at any time to ensure accuracy or relevance. These updates are included in your lifetime access license.
              </p>
            </section>

            <section className="pt-8 border-t border-slate-200">
              <p className="font-bold text-slate-900">
                By completing your purchase, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions.
              </p>
            </section>
          </div>
        </FadeIn>
      </div>
    </div>
  );
}